// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__26iz5","text":"SelectPayment_text__XgJ-8","title":"SelectPayment_title__31983","btn":"SelectPayment_btn__3I8j1"};